import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/api/authApi';
import { setOn401Handler } from '@/api/client';
import { useAuthStore } from '@/state/authStore';
import { useQueryClient } from '@tanstack/react-query';

/** Boots auth state once on app mount. Wires the global 401 handler so any
 * stale session triggers a clean logout + redirect. */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const setUser = useAuthStore((s) => s.setUser);
  const setLoading = useAuthStore((s) => s.setLoading);
  const navigate = useNavigate();
  const qc = useQueryClient();
  const booted = useRef(false);

  useEffect(() => {
    if (booted.current) return;
    booted.current = true;

    setOn401Handler(() => {
      setUser(null);
      qc.clear();
      navigate('/login', { replace: true });
    });

    setLoading(true);
    authApi
      .me()
      .then((u) => setUser(u))
      .catch(() => setUser(null));
  }, [setUser, setLoading, navigate, qc]);

  return <>{children}</>;
}
